import { z } from "zod";
import { CommercialLicenseStatus } from "../generated/gql/schema-types";

export const NANOID_CUSTOM_ALPHABET =
  "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const ORG_ROOT = "org_root";

export type UploadBucketKey =
  | "MUSIC_INGESTION"
  | "GENERAL"
  | "STATEMENT_IMPORTS";
export const STATEMENT_IMPORTS_KEY_PREFIX = "statement-imports/";
// The backend buffers and parses the whole file in memory.
export const STATEMENT_IMPORTS_MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
// User action log reference for track downloads ("player:track", stems "player:track:stem")
export const TRACK_DOWNLOAD_REFERENCE_PREFIX = "player:track";
export const ORG_ROOT_WORKSPACE = "songtradr";
export const ORG_ROOT_LEGACY_ID = "6315c04cc80bc8cf4fa3be2a"; // Songtradr Root Org ID | Old Studio

export const LAB_APP_ROLE_ID_PATTERN = /^[a-z]+(-[a-z]+)*$/;

export const COMMERCIAL_LICENSE_TERM_STATUS_PRIORITY = [
  CommercialLicenseStatus.Expired,
  CommercialLicenseStatus.SoonToExpire,
  CommercialLicenseStatus.Undefined,
  CommercialLicenseStatus.Active,
  CommercialLicenseStatus.InPerpetuity,
];

export enum STEM_MODEL_ID {
  instrumental = "1669b5b2", // AudioShake | instrumental
  vocals = "82a0124e", // AudioShake | vocals
  drums = "ee07b9b7", // AudioShake | drums
  bass = "845555c9", // AudioShake | bass
  guitar = "234cd556", // AudioShake | guitar
  piano = "300d2373", // AudioShake | piano
  underscore = "fa63f1aa", // AudioShake | other-x-guitar
  fullUnderscore = "fa7a194e", // AudioShake | other
}

/** Product-facing stem names, not the AudioShake model labels. */
export const STEM_MODEL_NAME: Record<STEM_MODEL_ID, string> = {
  [STEM_MODEL_ID.bass]: "Bass",
  [STEM_MODEL_ID.drums]: "Drums",
  [STEM_MODEL_ID.piano]: "Piano",
  [STEM_MODEL_ID.guitar]: "Guitar",
  [STEM_MODEL_ID.vocals]: "Vocals",
  [STEM_MODEL_ID.underscore]: "Harmony",
  [STEM_MODEL_ID.fullUnderscore]: "Melody",
  [STEM_MODEL_ID.instrumental]: "Instrumental",
};

/** The platform payout minimum; an org can raise its own minimum but never go below it. */
export const DEFAULT_MINIMUM_PAYOUT_CENTS = 1000;

export const MinimumPayoutCentsSchema = z
  .number()
  .int()
  .min(DEFAULT_MINIMUM_PAYOUT_CENTS);
